// extracted by mini-css-extract-plugin
export var anchorLinkMenu = "anchorLinks-module--anchorLinkMenu--a871c";
export var anchorLinkMenuLabel = "anchorLinks-module--anchorLinkMenuLabel--62f41";
export var anchorLinks = "anchorLinks-module--anchorLinks--94471";
export var anchorLinksDark = "anchorLinks-module--anchorLinksDark--c4408";
export var arrowUp = "anchorLinks-module--arrowUp--ce468";
export var backToTopButton = "anchorLinks-module--backToTopButton--22f37";
export var desktopAnchors = "anchorLinks-module--desktopAnchors--5a806";
export var lockScroll = "anchorLinks-module--lockScroll--c4ee3";
export var menuIsOpen = "anchorLinks-module--menuIsOpen--18140";
export var mobileAnchors = "anchorLinks-module--mobileAnchors--313a3";
export var openMenuButton = "anchorLinks-module--openMenuButton--00caa";
export var selectedAnchor = "anchorLinks-module--selectedAnchor--489a9";
export var selectedMenuLabel = "anchorLinks-module--selectedMenuLabel--22e67";